import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PricelistDownloadComponent } from './pricelist-download.component';

const routes: Routes = [
  {
    path:'**',
    component: PricelistDownloadComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PricelistDownloadRoutingModule { }
